//@ts-check

class AuditorsDashboardService {
    constructor(
        $http,
        $window,
        $timeout,
        $rootScope,
        InternalLinksService,
        LocalStorageService,
        NavigationService
    ) {
        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.InternalLinksService = InternalLinksService;
        this.LocalStorageService = LocalStorageService;
        this.NavigationService = NavigationService;

        this.init();
    }

    init() {
        this.auditsHeaderDetails = {};
    }

    async GetAuditorSchemes(Token) {
        let promise, promiseHandler = {};

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!Token) {
                throw new Error('auditorHeaderId must be supplied.');
            }

            await this.InternalLinksService.getLinks('audits/links', false);
            let url = await this.InternalLinksService.getLink('GetAuditorDashboard');
            if (!url) {
                url = await this.InternalLinksService.getLink('GetAuditorDashboard');
            }

            url = `${url}?Token=${Token}`;
            const results = await this.$http.get(url);
            const { data } = results;

            this.auditsHeaderDetails = this._map(data);
            this.$timeout(() => promiseHandler.resolve(data));
        } catch (err) {
            const msg = `Error while fetching auditors token history data`;
            console.error(msg, err);
            this.auditsQueryLogs = {};
            this.$timeout(() => promiseHandler.reject(err));
        }
        return promise;
    }

    async openAuditsDetails(Token) {
        let promise, promiseHandler = {};

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!Token) {
                throw new Error('Token must be supplied.');
            }

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('OpenAuditsDetails');
            var newUrl = url.split("audits");
            var startUrl = newUrl[0];
            if (!url) {
                url = await this.InternalLinksService.getLink('OpenAuditsDetails');
            }

            this.NavigationService.getAuditsInfo()
        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

    async getAuditorByAuditorHeaderId(auditorHeaderId) {
        let promise, promiseHandler = {};

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!auditorHeaderId) {
                throw new Error('auditorHeaderId  must be supplied.');
            }

            await this.InternalLinksService.getLinks('audits/links', false);
            let url = await this.InternalLinksService.getLink('GetAuditorByAuditorHeaderId');
            if (!url) {
                url = await this.InternalLinksService.getLink('GetAuditorByAuditorHeaderId');
            }
            url = `${url}?auditorHeaderId=${auditorHeaderId}`;

            const results = await this.$http.get(url);
            const { data } = results;

            this.auditorHeaderDetails = this._map(data);
            this.$timeout(() => promiseHandler.resolve(data));
        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);
            this.auditsQueryLogs = {};
            this.$timeout(() => promiseHandler.reject(err));
        }
        return promise;
    }


    async GetAuditDetailsToView(FinancialPeriodHeaderId, DB_Ref) {
        let promise, promiseHandler;

        var payload = {
            FinancialPeriodHeaderId: FinancialPeriodHeaderId,
            DB_Ref: DB_Ref
        }

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!payload) {
                throw new Error('The payload must be supplied.');
            }

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('GetAuditDetailsToView');
            if (!url) {
                url = await this.InternalLinksService.getLink('GetAuditDetailsToView');
            }

            const results = await this.$http.post(url, payload);
            const { data } = results;

            this.auditorHeaderDetails = this._map(data);
            this.$timeout(() => promiseHandler.resolve(data));

            this.$timeout(() => promiseHandler.resolve(data));
        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);
            this.$timeout(() => promiseHandler.reject(err));
        }
        return promise;
    }

    _map(data) {
        if (!data) return data;
        return data;
    }

    async GetAuditorDashboardToExcel(auditorHeaderId) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!auditorHeaderId) {
                throw new Error('auditorHeaderId  must be supplied.');
            }

            await this.InternalLinksService.getLinks('audits/links', false);

            let url = await this.InternalLinksService.getLink('GetAuditorDashboardToExcel');

            url = `${url}?auditorsId=${auditorHeaderId}`;

            const results = await this.$http.get(url);
            const { data } = results;
            this.$timeout(() => promiseHandler.resolve(data));

        } catch (err) {
            const msg = `Error while fetching audits token history data`;
            console.error(msg, err);
            this.$timeout(() => promiseHandler.reject(err));
        }
        return promise;
    }
}

export default /* @ngInject */ ($http, $window, $timeout, $rootScope, InternalLinksService, LocalStorageService, NavigationService) =>
	new AuditorsDashboardService($http, $window, $timeout, $rootScope, InternalLinksService, LocalStorageService, NavigationService);
